import React from 'react';
import { Card } from '../components/ui/card';
import { CheckCircle, Award, TrendingUp, Star } from 'lucide-react';
import { mockData } from '../data/mockData';

const iconMap = {
  CheckCircle: CheckCircle,
  Award: Award,
  TrendingUp: TrendingUp,
  Star: Star
};

const TrustSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Trusted by Thousands of Businesses
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our track record speaks for itself. We've helped over 1,000 businesses successfully register their trademarks with the USPTO.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {mockData.trustSignals.map((signal, index) => {
              const IconComponent = iconMap[signal.icon];
              return (
                <Card
                  key={index}
                  className="p-6 text-center bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-t-4 border-amber-500"
                >
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <IconComponent className="text-blue-900" size={32} />
                  </div>
                  <h3 className="text-lg font-bold text-blue-900 mb-2">
                    {signal.title}
                  </h3>
                  <p className="text-gray-600 text-sm">
                    {signal.description}
                  </p>
                </Card>
              );
            })}
          </div>

          {/* Testimonials */}
          <div>
            <h3 className="text-3xl font-bold text-blue-900 text-center mb-8">
              What Our Clients Say
            </h3>
            <div className="grid md:grid-cols-3 gap-8">
              {mockData.testimonials.map((testimonial, index) => (
                <Card key={index} className="p-6 bg-white shadow-lg hover:shadow-xl transition-all">
                  <div className="flex mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="text-amber-500 fill-amber-500" size={20} />
                    ))}
                  </div>
                  <p className="text-gray-700 italic mb-4">
                    "{testimonial.text}"
                  </p>
                  <div className="border-t pt-4">
                    <p className="font-bold text-blue-900">{testimonial.name}</p>
                    <p className="text-sm text-gray-600">{testimonial.company}</p>
                  </div>
                </Card>
              ))}
            </div>
          </div>

          <div className="mt-12 bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-center text-white">
            <h3 className="text-3xl font-bold mb-4">
              Join 1,000+ Satisfied Clients
            </h3>
            <p className="text-lg text-blue-100 mb-6 max-w-2xl mx-auto">
              Our commitment to excellence has earned us a reputation as one of the most trusted trademark registration services in the United States.
            </p>
            <div className="flex flex-wrap justify-center gap-8">
              <div>
                <div className="text-4xl font-bold text-amber-400">98%</div>
                <div className="text-blue-100">Client Satisfaction</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-amber-400">4.9/5</div>
                <div className="text-blue-100">Average Rating</div>
              </div>
              <div>
                <div className="text-4xl font-bold text-amber-400">24/7</div>
                <div className="text-blue-100">Support Available</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
